import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PasswordInput } from "@/components/PasswordInput";
import { api, errMsg } from "@/lib/api";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Nytt passord må ha minst 8 tegn");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Passordet er endret");
      setCur("");
      setPw("");
      onOpenChange(false);
    } catch (ex) {
      toast.error(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Bytt passord</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label>Nåværende passord</Label>
            <PasswordInput value={cur} onChange={(e) => setCur(e.target.value)} testId="change-password-current" />
          </div>
          <div className="space-y-2">
            <Label>Nytt passord (minst 8 tegn)</Label>
            <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" testId="change-password-new" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="change-password-submit">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Lagre
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
